import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AI_PDF_CONST from "../util/PdfAiConst";

const PrivateRoute = ({ element }) => {
  const location = useLocation();
  const isAuthenticated = Boolean(localStorage.getItem("token"));

  if (!isAuthenticated) {
    return <Navigate to={AI_PDF_CONST.ROUTE.LOGIN} replace state={{ from: location }} />;
  }

  return element;
};

export default PrivateRoute;
